import { Card } from "@/components/ui/card";
import { Lead } from "./types";
import { LeadContent } from "./card/LeadContent";
import { EditLeadDialog } from "./dialogs/EditLeadDialog";
import { ConvertLeadDialog } from "./dialogs/ConvertLeadDialog";
import { useLeadActions } from "./hooks/useLeadActions";

interface LeadCardProps {
  lead: Lead;
  onLeadUpdated?: () => void;
}

export const LeadCard = ({ lead, onLeadUpdated }: LeadCardProps) => {
  const {
    isDialogOpen,
    setIsDialogOpen,
    isEditDialogOpen,
    setIsEditDialogOpen,
    editedLead,
    setEditedLead,
    handleDelete,
    handleEditSubmit,
  } = useLeadActions(lead, onLeadUpdated);

  const handleCardClick = () => {
    setIsDialogOpen(true);
  };

  return (
    <>
      <Card 
        className="p-6 hover:shadow-lg transition-all duration-200 bg-white rounded-2xl border border-gray-100 cursor-pointer relative group"
        onClick={handleCardClick}
      >
        <LeadContent
          lead={lead}
          onEdit={(e) => {
            e.stopPropagation();
            setIsEditDialogOpen(true);
          }}
          onDelete={handleDelete}
          onConvert={(e) => {
            e.stopPropagation();
            setIsDialogOpen(true);
          }}
        />
      </Card>

      <EditLeadDialog
        isOpen={isEditDialogOpen}
        onClose={() => setIsEditDialogOpen(false)}
        lead={lead}
        editedLead={editedLead}
        setEditedLead={setEditedLead}
        onSubmit={handleEditSubmit}
      />

      <ConvertLeadDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        lead={lead}
        onConvert={() => {
          setIsDialogOpen(false);
          if (onLeadUpdated) onLeadUpdated();
        }}
      />
    </>
  );
};